import { BasePreviewViewStore } from "core/stores";
import { applicationContext } from "core/utils";
import { ProductService } from "application/product/services";
import { action } from "mobx";

@applicationContext
class ProductPreviewViewStore extends BasePreviewViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new ProductService(
            rootStore.application.baasic.apiClient
        );

        super(rootStore, {
            name: "role",
            id: id,
            authorization: "productCatalogSection.read",
            actions: () => {
                return {
                    get: async (id) => {
                        const response = await service.get(id, {
                            embed: "ItemType,InnerCannula,DefaultItemType,Vendor,ProductProductTags,PumpBrand,ItemCategory,SubCategory,ProcedureCode_,UnitOfMeasure,SpecialtyType,ParentProduct,HeightMeasurementUnitId,WidthMeasurementUnitId,WoundCareItemSubCategoryId",
                        });
                        return response.data;
                    },
                };
            },
        });

        this.hasCreatePermission = this.rootStore.permissionStore.hasPermission(
            "productCatalogSection.create"
        );
    }

    @action.bound
    goToEditPage() {
        this.rootStore.routerStore.setTransitionData({
            navigationTitle: this.item.name,
        });
        this.rootStore.routerStore.goTo("master.app.main.product.edit", {
            id: this.id,
        });
    }

    @action.bound
    goToProductHistory() {
        window.open(
            `${
                this.rootStore.routerStore.findRoute(
                    "master.app.main.product.product-history.list"
                ).pattern
            }?productId=${this.id}`
        );
    }
}

export default ProductPreviewViewStore;
